export const points: { [key: string]: string } = {
	N: `(nasion), Most anterior point on frontonasal suture`,
	S: `(sella), the midpoint of the cavity of sella turcica`,
	Or: `(orbitale), the lowest point on the inferior margin of the orbit`,
	Pt: `(Pterygo-maxillary fissure), Point at base of fissure where anterior and posterior wall meet. Anterior wall represents posterior surface of maxillary tuberosity`,
	A: `the innermost point on the contour of the premaxilla between anterior nasal spine and the incisor tooth`,
	B: `the innermost point on the contour of the mandible between the incisor tooth and the bony chin`,
	Pg: `(pogonion), the most anterior point on the contour of the chin`,
	Me: `(menton), the most inferior point on the mandibular symphysis(i.e., the bottom of the chin)`,
	Gn: `(gnathion), Point located perpendicular on mandibular symphysis midway between pogonion and menton`,
	Go: `(gonion), the midpoint of the contour connecting the ramus and body of the mandible`,
	Ba: `(basion), the lowest point on the anterior margin of the foramen magnum, at the base of the clivus`,
	Po: `(porion), the midpoint of the upper contour of the external auditory canal (anatomic porion); or the midpoint of the upper contour of the metal ear rod of the cephalometer(machine porion)`,
	UIa: 'Upper incisor apex',
	UIe: 'Upper incisor edge',
	LIe: 'Lower incisor edge',
	LIa: 'Lower incisor apex',
	OLp: 'Occlusal Line, posterior point, distal tip of the first molar',
	OLa: 'Occlusal Line, anterior point, distal tip of the first premolar',
	ANS: 'Anterior nasal spine',
	PNS: 'Posterior nasal spine',
	Pog: 'the most anterior point on the bony chin',
	'0mm': 'The point at which the ruler starts',
	'10mm': 'The point at which the ruler reads 10 millimeters',
	NMP:
		'A point at the ANS-PNS line that would draw a line where the nasion would meet the ANS-PNS line in a perpendicular way',
	MMP:
		'A point at the ANS-PNS line that would draw a line where the menton would meet the ANS-PNS line in a perpendicular way',
	AOP:
		'A point at the occlusal plane that would draw a line where point A would meet the occlusal plane in a perpendicular way',
	BOP:
		'A point at the occlusal plane that would draw a line where point A would meet the occlusal plane in a perpendicular way',
	Ms: 'the mesial cusp tip of the maxillary first molar',
	Mi: 'the mesial cusp tip of the mandibular first molar',
	EAP: 'A point at the A-Pog line coming from the upper incisor edge'
};

